<template>
    <el-row class="title-box">
        <el-col :span="8">
            &nbsp;

        </el-col>

        <el-col :span="8">
            <span class="title-span" tkey="3D店鋪">{{i18n.tkey("lang_my_3D_shop")}}</span>
        </el-col>

        <el-col :span="8" class="btn-box-part">
            &nbsp;
        </el-col>
    </el-row>
</template>

<script setup>
    import {inject, toRef} from "vue";

    const i18n = inject("i18n")
</script>

<style scoped>
    .title-box {

    }

    .title-span {
        font-weight: 600;
        font-size: 18px;
        line-height: 1.5;
    }

    .btn-box-part {
        text-align: right;
    }
</style>